var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M246.8,176.4c2.6-10.4,9.5-20.4,12.6-30.8c3-9.9,0.7-20.6,9.9-31.9c12.1-14.8,44.9-19.9,69.6-22.4 c-6.7,0.1-13.3,0.2-19.7,0.5c-17.2,0.9-34.1,2-48.5,11c-16.6,10.4-18.3,20.4-22.3,37c-3.7,15.5-11.7,33.1-11.1,49 c0.5,15.8,7.1,40,12.2,46.2c0.4,0.5,0.9,1,1.3,1.5C252.3,215.6,241.7,196.9,246.8,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M454.6,129.2c-3-16-5.7-26.6-23.7-33c-16.7-6-38-5.8-55.4-5.2c-11.8,0.3-24.3,0.2-36.6,0.3 c-24.7,2.5-57.5,7.6-69.6,22.4c-9.2,11.3-6.9,22-9.9,31.9c-3.1,10.4-10,20.4-12.6,30.8c-5.1,20.6,5.5,39.3,4,60.1 c3.8,4.7,6.2,10.6,7.9,16.1c1.9-9.4-4.4-23.1,1.4-44.1c1.9-7,8-14.1,12.8-19.9c6-7.3,5.8-10.6,6.4-19.9 c1.3-19.9,15.1-20.7,33.1-18.1c17.3,2.5,33.4,6.4,52.1,4.2c17.1-2,33.7-9.5,49.3-7.6c21.8,2.6,17,21.5,22,37.5 c4.1,13.2,13.1,17.3,15.9,39.9c1.7,13.7,3.1,24.9,2.5,41.4c17.9-38.1,9.5-60.1,12-93.6C467.5,156.2,457.9,147.1,454.6,129.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle3D);
export default __webpack_public_path__ + "static/media/man_hairstyle_3d.67e6af68045d48e486810ca85f0cd7a7.svg";
export { ForwardRef as ReactComponent };